import React, { useState, useEffect, useMemo } from "react";
import calcSmall from "../../PicesForPages/calc-small.jpg";

function HomePageMonthlyPayment() {
  const [loanAmount, setLoanAmount] = useState("100000");
  const [monthlyPayments, setMonthlyPayments] = useState([null, null, null]);

  const loanDetails = useMemo(
    () => [
      { term: 30, interestRate: 6.196, apr: 6.272, label: "30 Yr Fxd" },
      { term: 30, interestRate: 5.458, apr: 6.551, label: "30 Yr Fxd FHA" },
      { term: 15, interestRate: 5.521, apr: 5.649, label: "15 Yr Fxd" },
    ],
    [],
  ); // Empty dependency array ensures it's only initialized once.

  useEffect(() => {
    const principal = parseFloat(loanAmount);
    if (!principal || principal <= 0) {
      setMonthlyPayments([null, null, null]);
      return;
    }

    const payments = loanDetails.map(({ term, interestRate }) => {
      const monthlyInterest = parseFloat(interestRate) / 100 / 12;
      const totalMonths = term * 12;

      if (monthlyInterest === 0) {
        return (principal / totalMonths).toFixed(2); // Simple division for zero interest
      }

      const monthlyPayment =
        (principal * monthlyInterest) /
        (1 - Math.pow(1 + monthlyInterest, -totalMonths));

      return monthlyPayment.toFixed(2);
    });

    setMonthlyPayments(payments);
  }, [loanAmount, loanDetails]); // No warning because loanDetails reference is stable.

  return (
    <div className="calculateBoxParent">
      <div className="calculateBox">
        <div className="calculator">
          <div className="calculateHeading">Monthly Payment Estimate*</div>
          <div className="calculateContentBox">
            <span>
              <img
                fetchPriority="high"
                loading="eager"
                src={calcSmall}
                alt="Calculator"
                className="calcSmallImage"
              />
            </span>
            <span className="calculatorLeftSide">
              <table
                className="mpc table table-responsive"
                cellSpacing="0"
                cellPadding="0"
                border="0"
              >
                <thead>
                  <tr className="ths">
                    <th>Term</th>
                    <th>Rate</th>
                    <th>APR</th>
                    <th>Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {loanDetails.map((detail, index) => (
                    <tr key={index}>
                      <td>{detail.label}</td>
                      <td>{detail.interestRate}%</td>
                      <td>{detail.apr}%</td>
                      <td>${monthlyPayments[index] || "---"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <label htmlFor="loanAmount" className="calculatorInputText">
                Loan Amount ($)
                <input
                  type="number"
                  id="loanAmount"
                  className="calculatorInput"
                  value={loanAmount}
                  onChange={(e) => setLoanAmount(e.target.value)}
                  placeholder="Enter loan amount"
                />
              </label>
              <span className="calculatorPara">
                *=Figures are approximate and for guidance only. Final rates and
                payments may differ.
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePageMonthlyPayment;
